export const BUTTON_MODIFIERS = ['teeny', 'high', 'uppercase', 'orange'];

export const PRICE_LIST_LINK = 'https://kadromierz.pl/cennik';
